"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSuffix = exports.StyledStrikethrough = exports.StyledSavings = exports.StyledPromoStackable = exports.StyledPromoSavings = exports.StyledPromoDescription = exports.StyledPromo = exports.StyledPrice = exports.StyledPrefix = exports.StyledExtraPriceInfo = exports.StyledExternalPromo = exports.StyledCurrency = exports.StyledContainer = exports.StyledCents = exports.StyledBadge = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;

var StyledCents = _styledComponents["default"].span.withConfig({
  displayName: "Pricestyles__StyledCents",
  componentId: "sc-6tle0w-0"
})(["font-size:0.5em;vertical-align:super;"]);

exports.StyledCents = StyledCents;

var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledContainer",
  componentId: "sc-6tle0w-1"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["flex w-100 flex-wrap items-end lh-solid\n    ", "\n  "])), function (_ref) {
  var alignment = _ref.alignment;
  return alignment === 'right' && 'justify-end' || alignment === 'center' && 'justify-center' || alignment === 'left' && 'justify-start';
}));

exports.StyledContainer = StyledContainer;

var StyledBadge = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledBadge",
  componentId: "sc-6tle0w-2"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    inline-flex items-center\n    ", "\n  "])), function (_ref2) {
  var size = _ref2.size;
  return size === 'normal' ? 'w3 pr3' : 'w2 pr1';
}));

exports.StyledBadge = StyledBadge;

var StyledPrefix = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledPrefix",
  componentId: "sc-6tle0w-3"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 pb1 f6\n    ", "\n    ", "\n    ", "\n  "])), function (_ref3) {
  var inline = _ref3.inline;
  return inline ? 'dib' : '';
}, function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === 'right' && 'tr' || alignment === 'center' && 'tc' || alignment === 'left' && 'tl';
}, function (_ref5) {
  var price = _ref5.theme.price;
  return price === null || price === void 0 ? void 0 : price.prefix;
}), function (_ref6) {
  var _price$displayOrder;

  var price = _ref6.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder = price.displayOrder) === null || _price$displayOrder === void 0 ? void 0 : _price$displayOrder.prefix;
});

exports.StyledPrefix = StyledPrefix;

var StyledPromo = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledPromo",
  componentId: "sc-6tle0w-4"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    pb1 flex-wrap\n    ", "\n    ", "\n  "])), function (_ref7) {
  var alignment = _ref7.alignment;
  return alignment === 'right' && 'justify-end tr' || alignment === 'center' && 'justify-center tc' || alignment === 'left' && 'pr2 tl';
}, function (_ref8) {
  var price = _ref8.theme.price;
  return price === null || price === void 0 ? void 0 : price.promo;
}), function (_ref9) {
  var _price$displayOrder2;

  var price = _ref9.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder2 = price.displayOrder) === null || _price$displayOrder2 === void 0 ? void 0 : _price$displayOrder2.promo;
});

exports.StyledPromo = StyledPromo;

var StyledPromoSavings = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledPromoSavings",
  componentId: "sc-6tle0w-5"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n    pb1 flex-wrap\n    ", "\n    ", "\n  "])), function (_ref10) {
  var alignment = _ref10.alignment;
  return alignment === 'right' && 'justify-end tr' || alignment === 'center' && 'justify-center tc' || alignment === 'left' && 'pr2 tl';
}, function (_ref11) {
  var price = _ref11.theme.price;
  return price === null || price === void 0 ? void 0 : price.promo;
}), function (_ref12) {
  var _price$displayOrder3;

  var price = _ref12.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder3 = price.displayOrder) === null || _price$displayOrder3 === void 0 ? void 0 : _price$displayOrder3.promoSavings;
});

exports.StyledPromoSavings = StyledPromoSavings;

var StyledPromoStackable = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledPromoStackable",
  componentId: "sc-6tle0w-6"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n    pb1 flex-wrap\n    ", "\n    ", "\n  "])), function (_ref13) {
  var alignment = _ref13.alignment;
  return alignment === 'right' && 'justify-end tr' || alignment === 'center' && 'justify-center tc pt1' || alignment === 'left' && 'pr2 tl';
}, function (_ref14) {
  var price = _ref14.theme.price;
  return price === null || price === void 0 ? void 0 : price.promo;
}), function (_ref15) {
  var _price$displayOrder4;

  var price = _ref15.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder4 = price.displayOrder) === null || _price$displayOrder4 === void 0 ? void 0 : _price$displayOrder4.stackable;
});

exports.StyledPromoStackable = StyledPromoStackable;

var StyledStrikethrough = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledStrikethrough",
  componentId: "sc-6tle0w-7"
})(["", ""], (0, _ty["default"])(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n    strike f6\n    ", "\n  "])), function (_ref16) {
  var alignment = _ref16.alignment;
  return alignment === 'right' && 'pl1' || alignment === 'center' && 'pl1' || alignment === 'left' && 'pr2';
}));

exports.StyledStrikethrough = StyledStrikethrough;

var StyledSavings = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledSavings",
  componentId: "sc-6tle0w-8"
})(["", ""], (0, _ty["default"])(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n    fw6 ttu f6 di\n    ", "\n    ", "\n  "])), function (_ref17) {
  var alignment = _ref17.alignment;
  return alignment === 'right' && 'pl1' || alignment === 'center' && 'pl1';
}, function (_ref18) {
  var price = _ref18.theme.price;
  return price === null || price === void 0 ? void 0 : price.savingsColor;
}));

exports.StyledSavings = StyledSavings;

var StyledExternalPromo = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledExternalPromo",
  componentId: "sc-6tle0w-9"
})(["white-space:pre-wrap;word-wrap:break-word;", ""], (0, _ty["default"])(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n    fw6 ttl f6 di\n    ", "\n    ", "\n  "])), function (_ref19) {
  var alignment = _ref19.alignment;
  return alignment === 'right' && 'pl1' || alignment === 'center' && 'pl1';
}, function (_ref20) {
  var price = _ref20.theme.price;
  return price === null || price === void 0 ? void 0 : price.savingsColor;
}));

exports.StyledExternalPromo = StyledExternalPromo;

var StyledPrice = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledPrice",
  componentId: "sc-6tle0w-10"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), function (_ref21) {
  var size = _ref21.size;
  return size === 'text' ? 'fw4' : 'fw6';
}, function (_ref22) {
  var inline = _ref22.inline;
  return inline ? 'dib' : '';
}, function (_ref23) {
  var price = _ref23.theme.price;
  return price === null || price === void 0 ? void 0 : price.color;
}, function (_ref24) {
  var size = _ref24.size,
      price = _ref24.theme.price;
  return size === 'normal' && 'f1' || size === 'small' && (price === null || price === void 0 ? void 0 : price.priceFontSizeSmall) || size === 'text' && (price === null || price === void 0 ? void 0 : price.priceFontSizeExSmall);
}, function (_ref25) {
  var alignment = _ref25.alignment;
  return alignment === 'left' && 'pr2 tl' || alignment === 'center' && 'tc' || alignment === 'right' && 'tr';
}), function (_ref26) {
  var _price$displayOrder5;

  var price = _ref26.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder5 = price.displayOrder) === null || _price$displayOrder5 === void 0 ? void 0 : _price$displayOrder5.price;
});

exports.StyledPrice = StyledPrice;

var StyledCurrency = _styledComponents["default"].span.withConfig({
  displayName: "Pricestyles__StyledCurrency",
  componentId: "sc-6tle0w-11"
})(["", " ", ""], (0, _ty["default"])(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n  "])), function (_ref27) {
  var hasBadge = _ref27.hasBadge,
      size = _ref27.size;
  return hasBadge && size === 'normal' && 'nl1';
}), function (_ref28) {
  var superscriptCurrency = _ref28.theme.price.superscriptCurrency;
  return superscriptCurrency && "\n    font-size: 0.5em;\n    vertical-align: super;\n  ";
});

exports.StyledCurrency = StyledCurrency;

var StyledSuffix = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledSuffix",
  componentId: "sc-6tle0w-12"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject12 || (_templateObject12 = (0, _taggedTemplateLiteral2["default"])(["\n    pb1 f7 pl1\n    ", "\n  "])), function (_ref29) {
  var inline = _ref29.inline;
  return inline ? 'dib' : '';
}), function (_ref30) {
  var _price$displayOrder6;

  var price = _ref30.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder6 = price.displayOrder) === null || _price$displayOrder6 === void 0 ? void 0 : _price$displayOrder6.suffix;
});

exports.StyledSuffix = StyledSuffix;

var StyledPromoDescription = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledPromoDescription",
  componentId: "sc-6tle0w-13"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject13 || (_templateObject13 = (0, _taggedTemplateLiteral2["default"])(["pt1 fw7"]))), function (_ref31) {
  var _price$displayOrder7;

  var price = _ref31.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder7 = price.displayOrder) === null || _price$displayOrder7 === void 0 ? void 0 : _price$displayOrder7.promoDesc;
});

exports.StyledPromoDescription = StyledPromoDescription;

var StyledExtraPriceInfo = _styledComponents["default"].div.withConfig({
  displayName: "Pricestyles__StyledExtraPriceInfo",
  componentId: "sc-6tle0w-14"
})(["", " order:", ";"], (0, _ty["default"])(_templateObject14 || (_templateObject14 = (0, _taggedTemplateLiteral2["default"])(["\n    pt1\n    ", "\n  "])), function (_ref32) {
  var price = _ref32.theme.price;
  return price === null || price === void 0 ? void 0 : price.extraPriceInfo;
}), function (_ref33) {
  var _price$displayOrder8;

  var price = _ref33.theme.price;
  return price === null || price === void 0 ? void 0 : (_price$displayOrder8 = price.displayOrder) === null || _price$displayOrder8 === void 0 ? void 0 : _price$displayOrder8.extraPriceInfo;
});

exports.StyledExtraPriceInfo = StyledExtraPriceInfo;